/* eslint-disable max-len */

export const SENTRY_DSN = 'https://7b610ba4b753cac415565eb7e2c7f001@o4506038317744128.ingest.sentry.io/4506038658203648';

export const PRIVACY_STATEMENT_URL = 'https://www.smatch.com/datenschutzerklaerung/';
export const IMPRINT_URL = 'https://www.smatch.com/imprint/';
export const TERMS_URL = 'https://docs.google.com/document/d/e/2PACX-1vQHHxKn8cqIwYKqXKCq15LLmnmBgmzvabXmOqgf84zdNp3-ufUAhTp8a2r7DVQalA/pub';
export const FAQ_URL = 'https://www.smatch.com/faqs/';

export const CALENDLY_URL = 'https://calendly.com/smatch-support/smatch-demo';

/* eslint-enable */